import React, { useMemo } from 'react';
import Slider from 'react-slick';
import { useSelector } from 'react-redux';

import * as S from './CustomerStoriesStyles';
import {
	Heading,
	SubTitle,
	FlexDiv,
	GenericDiv,
	GenericP
} from 'commonStyles';
import { OrangeBorder } from '../../Style';
import { SliderArrowNext, SliderArrowPrev } from 'common/SliderArrows/SliderArrows';
import { trackClickEventSimple } from 'omnitures';

function CustomerStories({ isMobile }) {
	const custStoriesData = useSelector((state) => state.resource.custStoriesData || {});
	const { heading = '', subHeading = '', content = [] } = custStoriesData;

	const trackClick = (evt) => () => {
		trackClickEventSimple(evt);
	};

	const settings = useMemo(() => ({
		arrows: true,
		swipeToSlide: true,
		variableWidth: isMobile ? true : false,
		speed: 500,
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: false,
		nextArrow: <SliderArrowNext customClick={trackClick('right_clicked')} isMobile={isMobile} customClass='bottomAlign' />,
		prevArrow: <SliderArrowPrev customClick={trackClick('left_clicked')} isMobile={isMobile} customClass='bottomAlign' />,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	}), [isMobile]);

	return (
		<S.CustomerStoriesContainer id='CustomerStories'>
			<OrangeBorder />
			<GenericDiv left_P={`${isMobile ? '16' : 'auto'}`}>
				<Heading
					fontSize={`${isMobile ? '24px' : '40px'}`}
					marBt={`${isMobile ? '8px' : '4px'}`}
					dangerouslySetInnerHTML={{ __html: heading }}
				/>
			</GenericDiv>
			<GenericP
				fsize={`${isMobile ? '12px' : '16px'}`}
				left_M={`${isMobile ? '16' : 'auto'}`}
				right_M={`${isMobile ? '16' : 'auto'}`}>
				{subHeading}
			</GenericP>
			<S.SliderOuterWrap>
				<Slider {...settings}>
					{content && content.map((data, index) => {
						const { name, company, testimony, imgUrl } = data;
						return (
							<div key={index}>
								<S.CustomerStoriesInnerWrap id='stories'>
									<S.CustomerStoriesTextWrap>{testimony}</S.CustomerStoriesTextWrap>
									<FlexDiv justify='flex-end'>
										<FlexDiv
											justify='space-between'
											align='center'
											$width={`${isMobile ? '60px' : '88px'}`}
											height={`${isMobile ? '60px' : '88px'}`}
											right_M={`${isMobile ? '8' : '16'}`}>
											<img src={imgUrl} />
										</FlexDiv>
										<FlexDiv $direction='column' directionInMobile='column'>
											<SubTitle
												bottom_M='4'
												color='#3b385e'
												fSize={`${isMobile ? '18px' : '24px'}`}>
												{name}
											</SubTitle>
											<GenericP fsize='12px'>{company}</GenericP>
										</FlexDiv>
									</FlexDiv>
								</S.CustomerStoriesInnerWrap>
							</div>
						);
					})}
				</Slider>
			</S.SliderOuterWrap>
		</S.CustomerStoriesContainer>
	);
}

export default CustomerStories;
